import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { questionAnswered, questionErrored } from 'actions/questionnaires';
import { Mode } from 'common/questionnaires/types';
import DateDropdown from 'components/Common/Inputs/DateDropdown';
import moment from 'moment';
import isValid from 'date-fns/isValid';

const QuestionDateDropdown = ({ id, name, isForm, mode, className, maxDate, minDate, dateFormat, showToolTip, runValidation, dispatch }) => {
  const [startDate, setStartDate] = useState(null);

  const validateQuestion = () => {
    const dateFormatSchema = dateFormat && dateFormat.length > 0 ? dateFormat : 'MM dd, yyyy';
    const requiredFieldsComplete = (startDate !== null && isValid(moment(startDate, dateFormatSchema.toUpperCase()).toDate()));
    if (requiredFieldsComplete) {
      dispatch(questionAnswered({ id, answer: startDate, mode, isForm, name }));
    } else if (!requiredFieldsComplete && runValidation) {
      dispatch(questionErrored({ id, mode, isForm }));
    }
  };

  useEffect(() => {
    validateQuestion();
  }, [startDate, runValidation]);

  return (
    <DateDropdown
      id={ id }
      name={ name }
      className={ className }
      minDate={ minDate }
      maxDate={ maxDate }
      dateFormat={ dateFormat }
      showToolTip={ showToolTip }
      onChange={ (date) => { setStartDate(date); } }
    />
  );
};

QuestionDateDropdown.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  isForm: PropTypes.bool,
  mode: PropTypes.number.isRequired,
  dispatch: PropTypes.func.isRequired,
  maxDate: PropTypes.string,
  minDate: PropTypes.string,
  dateFormat: PropTypes.string,
  className: PropTypes.string,
  runValidation: PropTypes.bool,
  showToolTip: PropTypes.bool
};

QuestionDateDropdown.defaultProps = {
  name: null,
  maxDate: null,
  minDate: null,
  dateFormat: 'MM-dd-yyyy',
  showToolTip: true,
  className: null,
  isForm: false,
  runValidation: false,
};

const mapDispatchToProps = dispatch => ({ dispatch });

const mapStateToProps = (state) => {
  const {
    app: { onlineConfig },
    formQuestionnaire: { runValidation }
  } = state;

  return {
    mode: (onlineConfig && onlineConfig.preQualifyingQuestionnaireMode) ? onlineConfig.preQualifyingQuestionnaireMode : Mode.Crs,
    runValidation
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionDateDropdown);
